<template>
    <div id="entry" class="bg">
        <login-box :showLogin="showLogin" @closeLogin="closeBox" ref="login"></login-box>
        <div class="common-header container clearfix" @click="goHome">
            <div class="logo"></div>
            <div title="" class="title">{{ columnInfo.title }}机考模拟系统</div>
        </div>
        <div class="main">
            <section class="courseList">
                <div class="content">
                    <h2>{{ columnInfo.title }}机考模拟系统</h2>
                    <div class="tip">
                        <div class="tc">请您点击下列考试科目名称，进入机考模拟系统界面！推荐使用ie9以上浏览器</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in classData" :key="index" :title="item.title"
                                @click="mycourse(item)">
                                <a href="javascript:void(0);" target="_self">{{ item.title }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
        <div class="footer"></div>

        <!-- 选择试卷 -->
        <el-dialog title="模考试卷列表" custom-class="diags" :visible.sync="dialogPaperVisible" :close-on-click-modal="false"
            width="55%" :z-index="2006" append-to-body>
            <div class="paperBox">
                <div class="paperList" v-for="(item, index) in paperData" :key="index">
                    <div class="paperTitle">{{ index + 1 }}、{{ item.title }}</div>
                    <div class="paperButton" @click="goLogin(item.id)">进入机考</div>
                </div>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import LoginBox from "@/components/LoginBox";
export default {
    components: {
        LoginBox,
    },
    data() {
        return {
            showLogin: false,
            dialogPaperVisible: false,
            meauActive: "",
            column_id: 0,
            subject_id: 0,
            columnInfo: [],
            classData: [],
            paperData: [],
        };
    },
    mounted: function () {
        var query = this.$route.query;
        if (query.column_id) {
            this.column_id = query.column_id;
            this.getList();
        }
        if (query.subject_id) {
            this.subject_id = query.subject_id;
        }

    },
    methods: {
        //判断是否登录
        IsUsersLogin() {
            let token = sessionStorage.getItem("access-token");
            console.log(token);
            if (token) {
                return true;
            } else {
                this.showLogin = true;
                this.$refs.login.getMiQrCode();
                return false;
            }
        },

        closeBox(e) {
            this.showLogin = false;
        },

        goHome() {
            this.$confirm('确认要退出考试吗？?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push("/web/index");
            });
        },

        getList() {
            let that = this;
            let formData = {};
            formData.column_id = that.column_id;
            that.axios.post("/getColumnInfo", formData).then((res) => {
                if (res) {
                    that.classData = res.data.subject;
                    that.columnInfo = res.data;
                    sessionStorage.setItem("access-mecoName", res.data.title);
                }
            });
        },

        mycourse(e) {
            if (this.IsUsersLogin()) {
                sessionStorage.setItem("access-mecoId", e.id);
                sessionStorage.setItem("access-mecoTitle", e.title);
                //this.$router.push("/meco/login");
                this.dialogPaperVisible = true;
                let formData = {};
                formData.column_id = e.column_id;
                formData.subject_id = e.id;
                this.axios.post("/getExamPapers", formData).then((res) => {
                    if (res) {
                        this.paperData = res.data;
                    }
                });
            }
        },

        goLogin(e) {
            this.$router.push({
                path: "/doctor/login",
                query: {
                    paper_id: e,
                },
            });
        },

    },
};
</script>

<style>
@import "../../../../public/css/meco.css";

.paperBox {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.paperBox .paperList {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px dashed #ccc;
    align-items: center;
    padding: 10px 0;
}

.paperBox .paperList .paperTitle {
    width: 80%;
}

.paperBox .paperList .paperButton {
    width: 100px;
    text-align: center;
    border: 2px solid #409eff;
    height: 36px;
    line-height: 36px;
    border-radius: 6px;
    color: #409eff;
    cursor: pointer;
    font-size: 14px;
}

.diags .el-dialog__body {
    display: flex;
    flex-direction: column;
    height: 500px;
    overflow: scroll;
}
</style>